import type { ListBuilderList } from '../../../types';
import { createStandardTaskColumns } from '../columns';

/**
 * Default Tasks All (This Month) list configuration
 * Shows pending tasks due this month
 */
export const defaultTasksAllList: ListBuilderList = {
	id: 'default-tasks-all',
	cacheTTL: 300000,
	name: 'This Month',
	type: 'default',
	active: true,
	sortOrder: 5,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskPriority',
		'taskAssignedUser',
		'taskClient',
		'taskLeadOrCustomer',
		'taskDueDateRange',
		'taskExternalCalendars',
	],
	columns: createStandardTaskColumns(),
	defaultSortId: 'column-due-date-column-asc',
	filterRules: {
		taskAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
		},
		taskDueDateRange: {
			defaultValue: [
				{
					id: 'this-month',
					label: 'This Month',
					data: {
						startDate: '{{DATE:start_of_month}}',
						endDate: '{{DATE:end_of_month}}',
					},
				},
			],
		},
		taskStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
		},
	},
};
